import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { FileCard } from "@/components/FileCard";
import { Loader2, ChevronRight } from "lucide-react";

export default function CategoryDetail() {
  const { id } = useParams();
  const [c, setC] = useState(null);
  useEffect(() => { setC(null); api.get(`/categories/${id}`).then((r) => setC(r.data)).catch(() => {}); }, [id]);

  if (!c) return <div className="flex justify-center h-96 items-center text-slate-500"><Loader2 className="w-6 h-6 animate-spin" /></div>;

  return (
    <div className="space-y-8">
      <nav className="flex items-center gap-1.5 text-sm text-slate-500 flex-wrap">
        <Link to="/categories" className="hover:text-white">Categories</Link>
        {(c.path || []).map((p, i) => (
          <span key={i} className="flex items-center gap-1.5"><ChevronRight className="w-3.5 h-3.5" /><span className={i === c.path.length - 1 ? "text-slate-300" : ""}>{p}</span></span>
        ))}
      </nav>
      <div>
        <div className="text-[11px] uppercase tracking-widest text-blue-400 mb-1">{c.type}</div>
        <h1 className="font-display font-extrabold text-3xl text-white tracking-tight">{c.name}</h1>
        {c.description && <p className="text-slate-400 mt-2">{c.description}</p>}
        <div className="text-sm text-slate-500 mt-2">{c.file_count} file(s)</div>
      </div>
      {c.files?.length > 0 ? (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">{c.files.map((f, i) => <FileCard key={f.id} f={f} index={i} />)}</div>
      ) : <p className="text-slate-600 text-sm">No files in this category yet.</p>}
    </div>
  );
}
